import { IUser } from "./user.interface";


export interface IRegister {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  address: string;
  password: string;
  password_confirmation: string;
}

export interface ILogin {
  email: string;
  password: string;
}

export interface IAuthResponse {
  token: string;
  user: IUser;
}
